import { api, nullOn404 } from 'shared/api/client';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TagAnalysisResponse, UUID } from './types';

export const tagAnalysisQueryKeys = {
  analysis: 'TAG_ANALYSIS',
} as const;

export function useTagAnalysis(documentSuperId?: number, tagId?: UUID | null): UseQueryResult<TagAnalysisResponse | null> {
  return useQuery({
    queryKey: [tagAnalysisQueryKeys.analysis, documentSuperId, tagId],

    queryFn: async () => {
      if (!tagId) return null;
      return api
        .GET('/tags/{id}/analysis', { params: { path: { id: tagId } } })
        .then((res) => res.data)
        .catch(nullOn404);
    },

    enabled: !!documentSuperId && !!tagId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
